<template>
  <aha-dropdown-v2>
    <aha-dropdown-trigger-v2 :disabled="isDefaultCanvasBlock || loading">
      <div class="pl-3">
        <button

          class="improve-writing-dropdown-trigger "
          :class="{'disabled': isDefaultCanvasBlock, 'button-loading': loading, }"
        >
          <aha-icon name="sparkles-outline" class="mr-1" />
          <span class="whitespace-nowrap">{{ $i18nPresenter.t('Improve') }}</span>
          <aha-spinner

            v-if="loading"
            size="xs"
          />
          <aha-icon
            v-else
            name="down"
          />
        </button>
      </div>
    </aha-dropdown-trigger-v2>

    <aha-dropdown-menu :width="'250px'">
      <ImproveWritingButton
        v-for="(setting, settingIndex) in generalSettings"
        :key="settingIndex"
        :setting="setting"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('general', $event)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in toneSettings"
        :key="settingIndex"
        :setting="setting"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('tone', $event)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in complexitySettings"
        :key="settingIndex"
        :setting="setting"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('complexity', $event)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in lengthSettings"
        :key="settingIndex"
        :setting="setting"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('length', $event)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
    </aha-dropdown-menu>
  </aha-dropdown-v2>
</template>
<script >
import ImproveWritingButton from '@/components-v2/presentation-editor/freestyle/ImproveWritingButton.vue'
import renderCanvasBlocksUtils from '@/utils/renderCanvasBlocksUtils'

export default {
  components: {
    ImproveWritingButton,
  },
  props: {

    onImproveWritingButtonClicked: {
      type: Function,
      required: true,
    },
    isImprovingWriting: {
      type: Boolean,
      default: false,
    },
    blockData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      generalSettings: [
        {
          value: 'Correct spelling and grammar. Improve overall writing for clarity while keeping it succinct.', label: this.$i18nPresenter.t('General'), icon: '✨', nameIcon: 'sparkles-outline',
        },
      ],
      toneSettings: [
        {
          value: 'Make it humorous', label: this.$i18nPresenter.t('Make it Humorous'), icon: '🤩', nameIcon: 'humorous',
        },
        {
          value: 'Make it professional', label: this.$i18nPresenter.t('Make it Professional'), icon: '💼', nameIcon: 'professsional',
        },
      ],
      complexitySettings: [
        {
          value: 'Make it more analytical', label: this.$i18nPresenter.t('Make it Analytical'), icon: '📊', nameIcon: 'analytical',
        },
        {
          value: 'Make it more creative', label: this.$i18nPresenter.t('Make it Creative'), icon: '🎨', nameIcon: 'creative',
        },
      ],
      lengthSettings: [
        {
          value: 'Make it shorter', label: this.$i18nPresenter.t('Shorten it'), icon: '✂️', nameIcon: 'shorten',
        },
        {
          value: 'Rewrite the content, sentence by sentence, to make it longer. Add more details if necessary.', label: this.$i18nPresenter.t('Lengthen it'), icon: '✍️', nameIcon: 'lengthen',
        },
      ],
      isRestoringOriginalSlide: false,
    }
  },
  computed: {
    isDefaultCanvasBlock() {
      if (!this.blockData) return false
      const textBlock = this.blockData?.content?.value
      return renderCanvasBlocksUtils.isDefaultCanvasBlock(textBlock)
    },
  },
  methods: {
    async handleImproveWritingButtonClick(mode, value) {
      if (this.loading) return
      this.loading = true
      await this.onImproveWritingButtonClicked({ mode, value })
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.disabled{
  color :#9D9D9D;
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
  &:hover{
    color: #9D9D9D;
  }
}
.button-loading{
  cursor: pointer;
  pointer-events: none;
}
.improve-writing-dropdown-trigger{
  display: flex;
  color : #282E3E;
  align-items: center;
  gap: 4px;
  outline: none;

  &:hover{
    color: #6C6C6C;
    svg{
      path{
        fill: #6C6C6C;
      }
    }
  }
  // when press
  &:active{
    color: #282E3E;
    svg{
      path{
        fill: #282E3E;
      }
    }
  }

  &::v-deep{
    .aha-spinner{
      width:10px!important;
      height:10px!important;
    }
  }

}
</style>
